<template>
    <section class="top-swiper">
        <ul v-show="false">
            <li v-for="(item, index) in bannerList" :key="index">
                <img :src="item.pc_poster_img"/>
                <!-- <img v-if="device == 'mob'" :src="item.h_poster_img"/> -->
            </li>
        </ul>
        <div class="swiper-one">
            <div class="hvideo-box" v-show="isvis">
                <video ref="player"
                    class="video-js player"
                    x5-playinline="true" webkit-playsinline='true'
                    playsinline='true' x-webkit-airplay='true'
                    x5-video-player-type='h5' x5-video-player-fullscreen='true'
                    x5-video-ignore-metadata='true'
                ></video>
            </div>
            <div class="swiper-container" ref="swiperContainer">
                <div class="swiper-wrapper" v-if="bannerList.length > 0">
                    <div class="swiper-slide" v-for="(item, index) in bannerList" :key="index">
                        <img width="100%" class="bj_h5" src="@/assets/images/home/opac.png" />
                        <!-- <img v-if="device == 'mob'" width="100%" class="bj_h5" src="@/assets/images/home/hopac.png" /> -->
                        <img
                            class="ts-img"
                            :class="{'oct': isvis}"
                            :src="item.pc_poster_img"
                        />
                        <img class="opac" src="@/assets/images/home/opac.png" />
                        <div class="hmv-info">
                            <div class="web1" v-if="device =='web'">
                                <h4 @click="swiperTopage(1)">{{ item.name }}</h4>
                                <div class="tags" v-if="item.movieInfo">
                                    <span class="year">18 +</span>
                                    <span>{{ item.movieInfo.year_shooting }}</span>
                                    <span class="line">|</span>
                                    <span>{{ item.movieInfo.duration }} mins</span>
                                    <span class="line">|</span>
                                    <span>98% Match</span>
                                </div>
                                <p class="desc">
                                    {{ item.desc }}
                                </p>
                            </div>
                            <div class="btn-group" v-if="device =='web'">
                                <a class="play" href="javascript:void(0);"
                                    @click="linksToDetailHandler(item.movie_id)"
                                >
                                    <img src="@/assets/images/home/top_play.png" />{{ $t('home.1') }}
                                </a>
                                <a class="percom more" href="javascript:void(0);"
                                    @click="switchMovieInfoHandler(item.movie_id)"
                                >
                                    <img src="@/assets/images/home/top_info.png" /><i></i>{{ $t('home.2') }}
                                </a>
                            </div>
                            <div class="play-btn-h5" v-if="device =='mob'">
                                <a class="play" href="javascript:void(0);"
                                    @click="linksToDetailHandler(item.movie_id)"
                                >
                                </a>
                            </div>
                            <div v-if="false">
                                <span class="left-btn"  @click="leftSwiperHandler" v-if="device =='web'"></span>
                                <span id="rbtn" class="right-btn" @click="rightSwiperHandler" v-if="device =='web'"></span>

                                <span class="left-btn-h5"  @click="leftSwiperHandler" v-if="device =='mob'"></span>
                                <span class="right-btn-h5" @click="rightSwiperHandler" v-if="device =='mob'"></span>
                            </div>


                        </div>
                        <span v-if="svoice" class="i-voice" :class="curClass"
                            @click="switchVoiceHandler"
                        ></span>
                    </div>
                </div>
            </div>
            <div class="page-box" :class="{'web-device': device == 'web'}">
                <ul class="page-u">
                    <li v-for="(item, index) in bannerList" @click="swiperTopage(index)" :class="{'active': index == current}" :key="index">
                        <span class="progress" :style="{'width': progress}"></span>
                    </li>
                </ul>
            </div>
            <div class="hmv-info-h5" v-if="device =='mob'">
                <p class="h4" @click="swiperTopage(1)">{{ bannerList[current].name }}</p>
                <div class="tags" v-if="bannerList[current].movieInfo">
                    <span class="year">18 +</span>
                    <span>{{ bannerList[current].movieInfo.year_shooting }}</span>
                    <span class="line">|</span>
                    <span>{{ bannerList[current].movieInfo.duration }} mins</span>
                    <span class="line">|</span>
                    <span>98% Match</span>
                </div>
                <p class="desc">
                    {{ bannerList[current].desc }}
                </p>
            </div>
        </div>
    </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
import CinemaList from "@/components/Home/CinemaList";
export default {
    name: "TopSwiper",
    props: {
        bannerList: {
            type: Array,
            default: () => []
        },
        homeLists: {
            type: Object,
            default: () => {}
        },
    },
    data() {
        return {
            options: {},
            player: null,
            timer: null,
            current: window.localStorage.getItem('curIndex') || 0,
            tmpCur: 0,
            isvis: false,
            locale: window.localStorage.getItem("locale") || '1',
            token: window.localStorage.getItem('token'),
            curClass: "voice-c",
            svoice: false,
            swiper: null,
            progress: 0,
            actags: true
        };
    },
    mounted(){
        if(this.actags) this.progress = 100 + '%';
        const $this = this;
        this.current++;
        if( this.current >= this.bannerList.length ) this.current = 0;
        this.swiper = new this.$swiper(".swiper-container", {
            loop: false,
            pagination : '.swiper-pagination',
            autoplay: 100000000,
            allowTouchMove: false,
            navigation: {
                nextEl: '.right-btn',
                prevEl: '.left-btn'
            },
            initialSlide: this.current,
        });
        let cIndex = this.current;
        // this.$nextTick(() => {
        this.initHandler(cIndex);
        // });

        this.$once('hook:beforeDestroy', () => {
            this.player.dispose();
        })
    },
    methods: {
        ...mapActions({
            SetSiginStatusFn: "SetSiginStatusFn",
            SetLoadShowFn: "SetLoadShowFn",
            addLoadShowFn:"addLoadShowFn",
            getDataNikkatsuFn: "getDataNikkatsuFn"
        }),
        initHandler(index){
            window.localStorage.setItem('curIndex', index);
            const $this = this;
            // if(this.device == 'web'){
            //     this.options = this.$utils.initOptions(
            //         this.bannerList[index].pc_preview_url,
            //         true,
            //         true,
            //         false
            //     );
            // }else{
            //     this.options = this.$utils.initOptions(
            //         this.bannerList[index].h_preview_url,
            //         true,
            //         true,
            //         false
            //     );
            // }
            this.options = this.$utils.initOptions(
                this.bannerList[index].pc_preview_url,
                true,
                true,
                false
            );

            let oIndex = parseInt(this.current);
            this.timer = setTimeout(() => {
                this.svoice = true;
                this.isvis = true;
                this.player = this.$video(this.$refs.player, this.options);

                this.player.on("timeupdate",function(){
                    $this.progress = (this.currentTime()/this.duration() * 100) + '%';
                });
                this.player.on("ended", () => {
                    let next = oIndex + 1;
                    if(next == this.bannerList.length) next = 0;
                    this.swiperTopage(next);
                })
            }, 5000);
            // }
        },
        selectMdtHandler(index){
            const $this = this;
            this.locale = window.localStorage.getItem("locale") || '1'
            this.current = index;
            this.isvis = false;
            this.curClass = "voice-c";
            setTimeout( ()=> {
                this.progress = 100 + '%';
            }, 50)

            if(this.player){
                this.player.pause();
                this.svoice = false;
            }
            clearInterval(this.timer);
            this.timer = setTimeout(() => {
                this.svoice = true;
                this.isvis = true;
                this.player = this.$video(this.$refs.player, this.options);
                this.player.reset();
                // if(this.device == 'web'){
                //     this.player.src(
                //         [{ type: 'application/x-mpegURL', src: this.bannerList[this.current].pc_preview_url }]
                //     );
                // }else{
                //     this.player.src(
                //         [{ type: 'application/x-mpegURL', src: this.bannerList[this.current].h_preview_url }]
                //     );
                // }
                this.player.src(
                    [{ type: 'application/x-mpegURL', src: this.bannerList[this.current].pc_preview_url }]
                );

                this.player.load();
                this.player.play();
                let sIndex = parseInt(index);
                // if(this.device == "web"){
                this.player.on("ended", () => {
                    let next = sIndex + 1;
                    if(next == this.bannerList.length) next = 0;
                    this.swiperTopage(next);
                })
                // };
                this.player.on("timeupdate",function(){
                    $this.progress = (this.currentTime()/this.duration() * 100) + '%';
                });
            }, 5000);

        },
        switchMovieInfoHandler(mid){
            window.localStorage.setItem("mid", mid);
            this.$emit('show-detail');
        },
        linksToDetailHandler(mid){
            // 发送统计上报
            const sendDataNikkatsuFn = async() => {
                const result = await this.getDataNikkatsuFn( {up_type: 6} );
            }
            sendDataNikkatsuFn();

            if(window.localStorage.getItem("token")){
              this.SetLoadShowFn(false);
              this.addLoadShowFn(true).then(res => {
                this.$router.push('/serial/' + mid + '?pid=' + mid);
              })
            }else{
              window.localStorage.setItem('path', `/serial/${mid}?pid=${mid}`);
                this.SetSiginStatusFn(true);
            }
        },

        leftSwiperHandler(){
            this.current--;

            if(this.current == -1){
                // this.current = 0;
                this.current = this.bannerList.length -1;
                this.swiperTopage(this.bannerList.length -1);
            }else{
                this.swiperTopage(this.current);
            }
        },
        rightSwiperHandler(){
            this.current++;
            if(this.current == (this.bannerList.length)){
                this.current = 0;
                this.swiperTopage(0);
            }else{
                this.swiperTopage(this.current);
            }
            console.log(this.current)
        },
        switchVoiceHandler(){
            const boolVoice = this.player.muted();

            if (boolVoice == true) {
                this.player.muted(false);
                this.curClass = "voice-o";
            } else {
                this.curClass = "voice-c";
                this.player.muted(true);
            }
        },
        swiperTopage(index){
            window.localStorage.setItem('curIndex', index);
            this.actags = false;
            this.current = index;
            try{
              this.swiper.slideToLoop(index);
            }catch(err){
              this.swiper[0].slideToLoop(index);
            }
            this.selectMdtHandler(index);
        },
    },
    components: {
        CinemaList
    }

}
</script>
